import _OpenInNewOutlined from "@mui/icons-material/OpenInNewOutlined";
import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import React from 'react';
import globeOutlineIcon from '../../../assets/images/bfg/globe-outline.svg';
import BfgDetailsCard from './bfg-details-card';
import BfgExploreMapCard from './bfg-explore-map-card';
import BfgHowItWorksCard from './bfg-how-it-works-card';
import BfgScoreDetailCard from './bfg-score-detail-card';
import BfgSummaryVideoCard from './bfg-summary-video-card';
import BfgWhyCard from './bfg-why-card';
import CountdownCard from './countdown-card';
import InfoCard from './info';
import Progression from './progression';
import RankingCard from './ranking-card';
import Sponsors from './sponsors';
function BfgHome({
  Button,
  challenge,
  currentUser,
  employee,
  ownGeogroup,
  event,
  defaultParticipationGroup,
  hasExplorationMapTab,
  hasLotsTab,
  hasPotentialTab,
  hasStatsTab,
  HomeLotsCard,
  HomeMobilizationCard,
  HomeMobilizationFutureCard,
  HomeNextEventsCard,
  HomePrepareCard,
  HomeStatsCard,
  isMember,
  onFocusOwnCompanyInLeaderboard,
  selectLeaderboardScope,
  selectTab
}) {
  return /*#__PURE__*/React.createElement(_Box, {
    paddingY: 3,
    sx: {
      containerType: 'inline-size'
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@800': 'row'
    },
    gap: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2,
    width: {
      '@': '100%',
      '@800': 'calc(100% - 344px)'
    }
  }, isMember && challenge && event.period !== 'future' && /*#__PURE__*/React.createElement(BfgScoreDetailCard, {
    Button: Button,
    challenge: challenge,
    event: event,
    onFocusOwnCompanyInLeaderboard: onFocusOwnCompanyInLeaderboard,
    ownGeogroup: ownGeogroup,
    selectLeaderboardScope: selectLeaderboardScope,
    selectTab: selectTab
  }), isMember && employee?.isAdminOrAnimator && event.period === 'past' && HomeNextEventsCard && /*#__PURE__*/React.createElement(HomeNextEventsCard, {
    ownGeogroup: ownGeogroup
  }), event.period === 'future' && /*#__PURE__*/React.createElement(CountdownCard, {
    startDate: event.startDate
  }), !isMember && /*#__PURE__*/React.createElement(BfgDetailsCard, {
    event: event
  }), isMember && hasStatsTab && event.period !== 'future' && HomeStatsCard && /*#__PURE__*/React.createElement(HomeStatsCard, {
    challenge: challenge,
    event: event,
    onSeeAllClick: () => selectTab('stats'),
    ownGeogroup: ownGeogroup
  }), isMember && hasPotentialTab && event.period === 'current' && HomeMobilizationCard && /*#__PURE__*/React.createElement(HomeMobilizationCard, {
    challenge: challenge,
    event: event,
    ownGeogroup: ownGeogroup,
    selectTab: selectTab
  }), isMember && hasPotentialTab && event.period === 'future' && HomePrepareCard && /*#__PURE__*/React.createElement(HomePrepareCard, {
    challenge: challenge,
    event: event,
    ownGeogroup: ownGeogroup,
    selectTab: selectTab
  }), isMember && hasPotentialTab && event.period === 'future' && HomeMobilizationFutureCard && /*#__PURE__*/React.createElement(HomeMobilizationFutureCard, {
    event: event,
    ownGeogroup: ownGeogroup,
    selectTab: selectTab
  }), !isMember && /*#__PURE__*/React.createElement(BfgWhyCard, null), /*#__PURE__*/React.createElement(BfgHowItWorksCard, {
    Button: Button,
    onFaqClick: () => selectTab('faq')
  }), /*#__PURE__*/React.createElement(Progression, {
    event: event
  }), /*#__PURE__*/React.createElement(InfoCard, {
    event: event
  }), hasLotsTab && HomeLotsCard && /*#__PURE__*/React.createElement(HomeLotsCard, {
    onSeeAllClick: () => selectTab('lots')
  })), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 2,
    width: {
      '@': '100%',
      '@800': 320
    }
  }, /*#__PURE__*/React.createElement(Sponsors, {
    defaultParticipationGroup: defaultParticipationGroup,
    event: event
  }), event.dedicatedWebsiteUrl && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    component: "a",
    display: "flex",
    href: event.dedicatedWebsiteUrl,
    justifyContent: "space-between",
    padding: 3,
    rel: "noreferrer",
    sx: {
      textDecoration: 'none'
    },
    target: "_blank"
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    height: 16,
    src: globeOutlineIcon,
    width: 16
  }), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      color: '#326ac2',
      fontSize: 16,
      fontWeight: 600
    },
    variant: "body2"
  }, event.dedicatedWebsiteUrl.replace('https://', '').replace('http://', ''))), /*#__PURE__*/React.createElement(_OpenInNewOutlined, {
    sx: {
      color: '#666a6f',
      fontSize: 16
    }
  })), isMember && event.period === 'past' && challenge?.summaryVideo && /*#__PURE__*/React.createElement(BfgSummaryVideoCard, {
    event: event,
    videoUrl: challenge.summaryVideo
  }), isMember && hasExplorationMapTab && event.period === 'current' && event.h3GameId && /*#__PURE__*/React.createElement(BfgExploreMapCard, {
    Button: Button,
    event: event,
    ownGeogroup: ownGeogroup,
    selectTab: selectTab
  }), (event.period === 'current' || event.period === 'past') && /*#__PURE__*/React.createElement(RankingCard, {
    Button: Button,
    challenge: challenge,
    currentUser: currentUser,
    event: event,
    onFocusOwnCompanyInLeaderboard: onFocusOwnCompanyInLeaderboard,
    ownGeogroup: ownGeogroup,
    selectLeaderboardScope: selectLeaderboardScope,
    selectTab: selectTab
  }))));
}
export default BfgHome;